// ----------------------------------------------------------------------

export const HOST_DOMAIN = process.env.REACT_APP_DOMAIN;
export const HOST_API = process.env.REACT_APP_HOST_API;
export const IMAGE_BASE = process.env.REACT_APP_IMAGE_DOMAIN_BASE;

export const RECAPTCHA_KEY = process.env.REACT_APP_RECAPTCHA_KEY;
export const GETUAI_KEY = process.env.REACT_APP_GETUAI_KEY;

export const MAP_TEMPLATE_ID = process.env.REACT_APP_MAP;

export const GTM_ID = process.env.REACT_APP_GTM_ID;

// LAYOUT
// ----------------------------------------------------------------------

export const NAVBAR = {
    BASE_WIDTH: 260,
    BASE_DRAWER_WIDTH: 360,
    WIDE_DRAWER_WIDTH: 480,
    DASHBOARD_WIDTH: 240,
    DASHBOARD_COLLAPSE_WIDTH: 88,
    //
    DASHBOARD_ITEM_ROOT_HEIGHT: 48,
    DASHBOARD_ITEM_SUB_HEIGHT: 40,
    DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32
};

// TEMPLATE
// ----------------------------------------------------------------------

export const BOTTOM_BAR = {
    HEIGHT: 60,
    PADDING_Y: 14,
    PADDING_X: 20
};

export const POPUP = {
    IMAGE_HEIGHT: 240,
    ICON_WIDTH: 40,
    PADDING: 30,
    PADDING_B: 20,
    SPACING: 30,
    TEXT_SPACING: 10,
    SPACING_X: 20,
    BASE_RADIUS: 8,
    BASE_RADIUS_LARGE: 14
};

export const BUTTON = {
    BASE_WIDTH: 140,
    BASE_HEIGHT: 40,
    //
    PADDING_Y: 10,
    PADDING_X: 16,
    //
    BASE_RADIUS: 8
};

export const BUTTON_GROUP = {
    SPACING_X: 20
};

export const TEXT_GROUP = {
    TEXT_FIELD_SPACING_Y: 30,
    TEXT_FIELD_SPACING_X: 20
};

// export const SELECT = {
//     MIN_WIDTH: 120,
//     MAX_WIDTH: 160,
//     BASE_RADIUS: 8,
//     PADDING_Y: 8,
//     PADDING_X: 4,
//     MENU_MIN_WIDTH: 120,
//     MENU_MAX_WIDTH: "unset"
// };

// export const DROPDOWN = {
//     BASE_RADIUS: 8,
//     PADDING_Y: 6,
//     PADDING_X: 10,
//     SPACING: 4
// };

// export const DIALOG = {
//     SECTION_Y: 20,
//     ACTIONS_HEIGHT: 70,
//     ACTIONS_PADDING_Y: 15,
//     ACTIONS_PADDING_X: 30
// };

export const TABLE = {
    HEADER_HEIGHT: 36,
    PAGINATION_HEIGHT: 57,
};